import { render } from "./AdsSummeryWidget.vue?vue&type=template&id=1fd5b876&scoped=true&ts=true"
import script from "./AdsSummeryWidget.vue?vue&type=script&lang=ts"
export * from "./AdsSummeryWidget.vue?vue&type=script&lang=ts"

import "./AdsSummeryWidget.vue?vue&type=style&index=0&id=1fd5b876&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd5b876"]])

export default __exports__